import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";

/* eslint-disable import/prefer-default-export */
export function labelize(string) {
  var _context;

  return _mapInstanceProperty(_context = string.split(/[\W\s]/g)).call(_context, word => word.replace(/^(\w)/, w => w.toUpperCase())).join(' ');
}